import { Injectable, ApplicationRef, ViewContainerRef } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IConfirmationService } from 'sabis-chatbot';
import { AlertControllerService } from '../alert-controller/alert-controller.service';

/**
 * Service to handle chatbot confirmation dialogs.
 * This implements the IConfirmationService interface required by sabis-chatbot.
 */
@Injectable({
  providedIn: 'root'
})
export class ChatbotConfirmationService implements IConfirmationService {

  constructor(
    private _alertCtrl: AlertControllerService,
    private _appRef: ApplicationRef
  ) { }

  /**
   * Prompts the user to confirm closing the chatbot.
   * @returns An Observable that emits `true` if the user confirms, or `false` otherwise.
   */
  confirmCloseChatbot(): Observable<boolean> {
    // Get the root component's view container reference
    const rootComponent = this._appRef.components[0];
    const viewContainerRef = rootComponent.injector.get(ViewContainerRef);

    return this._alertCtrl.presentConfirm(
      'Are you sure you want to exit?',
      viewContainerRef,
      'Exit Check'
    );
  }

  /**
   * Prompts the user with an alert that they must fill the equation.
   * @returns An Observable that emits `true` if the user clicks ok
   */
  alertEmptyEquation(): Observable<boolean> {
    const rootComponent = this._appRef.components[0];
    const viewContainerRef = rootComponent.injector.get(ViewContainerRef);

    return this._alertCtrl.presentNotification(
      'Please fill in the equation.',
      viewContainerRef,
      'Equation Required'
    ).pipe(
      map(() => true)
    );
  }
}
